module.exports = __webpack_public_path__ + "static/media/rb.7874f8d7.png";